import { render, staticRenderFns } from "./employeeCompetencyDetailsModal.vue?vue&type=template&id=8a2aff8e&"
import script from "./employeeCompetencyDetailsModal.vue?vue&type=script&lang=js&"
export * from "./employeeCompetencyDetailsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports